import { render, staticRenderFns } from "./SpecialColumn.vue?vue&type=template&id=2718e2fe&scoped=true"
import script from "./SpecialColumn.vue?vue&type=script&lang=js"
export * from "./SpecialColumn.vue?vue&type=script&lang=js"
import style0 from "./SpecialColumn.vue?vue&type=style&index=0&id=2718e2fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2718e2fe",
  null
  
)

export default component.exports